import { withPending, withRejected, withFulFilled } from './commons';
import {
  CREATE_EVOLUTIVO_CONFIG,
  LIST_EVOLUTIVO_CONFIG,
  SELECT_EVOLUTIVO_CONFIG,
  REMOVE_EVOLUTIVO_CONFIG,
  UPDATE_EVOLUTIVO_CONFIG,
  FETCH_EVOLUTIVO_RESULT,
} from '../actions/configs';

// initial state
const INITIAL_STATE = {
  configuration: {
    running: false,
    error: null,
    payload: {}, // { id_configuracao: number }
    configs: {
      running: false,
      error: null,
      payload: [],
    },
    selected: null,
  },
  result: {
    running: false,
    error: null,
    payload: null, // os resultados sao um mapa que tem como chave o id da configuracao
  },
};

/**
 * cria um novo estado respondendo à action
 * withPending(CREATE_EVOLUTIVO_CONFIG).
 *
 * Basicamente seta running = true
 */
function updateConfigurationPending(state) {
  const newState = { ...state };
  newState.configuration.running = true;
  return newState;
}

/**
 * define qual problema ocorreu na configuracao
 * e set running como = false
 */
function updateConfigurationRejected(state, action) {
  const error = action.payload;
  const newState = { ...state };
  newState.configuration.running = false;
  newState.configuration.error = error;
  return newState;
}

/**
 * Define o id da configuracao criada, running=false / error = null
 */
function updateConfigurationFulfilled(state, action) {
  const newState = { ...state };
  newState.configuration.running = false;
  newState.configuration.error = null;
  newState.configuration.payload = action.payload;
  return newState;
}

/**
 * cria um novo estado respondendo à action
 * withPending(CREATE_EVOLUTIVO_CONFIG).
 *
 * Basicamente seta running = true
 */
function newConfigurationPending(state) {
  const newState = { ...state };
  newState.configuration.running = true;
  return newState;
}

/**
 * define qual problema ocorreu na configuracao
 * e set running como = false
 */
function newConfigurationRejected(state, action) {
  const error = action.payload;
  const newState = { ...state };
  newState.configuration.running = false;
  newState.configuration.error = error;
  return newState;
}

/**
 * Define o id da configuracao criada, running=false / error = null
 */
function newConfigurationFulfilled(state, action) {
  const newState = { ...state };
  newState.configuration.running = false;
  newState.configuration.error = null;
  newState.configuration.payload = action.payload;
  return newState;
}

/**
 * cria um novo estado respondendo à action
 * withPending(LIST_EVOLUTIVO_CONFIG).
 *
 * Basicamente seta running = true
 */
function listConfigurationsPending(state) {
  const newState = { ...state };
  newState.configuration.configs = { ...newState.configuration.configs };
  newState.configuration.configs.running = true;
  return newState;
}

/**
 * define qual problema ocorreu na listagem
 * e set running como = false
 */
function listConfigurationsRejected(state, action) {
  const error = action.payload;

  const newState = { ...state };
  newState.configuration.configs = { ...newState.configuration.configs };
  newState.configuration.configs.running = false;
  newState.configuration.configs.error = error;
  return newState;
}

/**
 * Define a listagem das configuracoes, running=false / error = null
 */
function listConfigurationsFulfilled(state, action) {
  const newState = { ...state };
  newState.configuration.configs = { ...newState.configuration.configs };
  newState.configuration.configs.running = false;
  newState.configuration.configs.error = null;
  newState.configuration.configs.payload = {};
  const payloadKey = `${action.meta.clientIdOnDispatch}_${action.meta.surveyIdOnDispatch}_${action.meta.questionIdOnDispatch}`;
  newState.configuration.configs.payload[payloadKey] = action.payload.data;

  return newState;
}

/**
 * cria um novo estado respondendo à action
 * withPending(FETCH_EVOLUTIVO_RESULT).
 *
 * Basicamente seta running = true
 */
function fetchConfigResultsPending(state) {
  const newState = { ...state };
  newState.result = { ...newState.result };
  newState.result.running = true;
  return newState;
}

/**
 * define qual problema ocorreu no fetch de resultados
 * e set running como = false
 */
function fetchConfigResultsRejected(state, action) {
  const error = action.payload;

  const newState = { ...state };
  newState.result = { ...newState.result };
  newState.result.running = false;
  newState.result.error = error;
  return newState;
}

/**
 * Define os resultados da configuracaoSelecionada, running=false / error = null
 */
function fetchConfigResultsFulfilled(state, action) {
  const newResultPayload = {};
  newResultPayload[action.meta.configId] = action.payload.data;

  const newState = { ...state };
  newState.result = { ...newState.result };
  newState.result.running = false;
  newState.result.error = null;
  newState.result.payload = newResultPayload;

  return newState;
}

// executer
const execute = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  /**
     * Cadastro
     */
  case withPending(CREATE_EVOLUTIVO_CONFIG):
    return newConfigurationPending(state, action);
  case withRejected(CREATE_EVOLUTIVO_CONFIG):
    return newConfigurationRejected(state, action);
  case withFulFilled(CREATE_EVOLUTIVO_CONFIG):
    return newConfigurationFulfilled(state, action);

    /**
     * Listagem
     */
  case withPending(LIST_EVOLUTIVO_CONFIG):
    return listConfigurationsPending(state, action);
  case withRejected(LIST_EVOLUTIVO_CONFIG):
    return listConfigurationsRejected(state, action);
  case withFulFilled(LIST_EVOLUTIVO_CONFIG):
    return listConfigurationsFulfilled(state, action);

    /**
     * Resultados
     */
  case withPending(FETCH_EVOLUTIVO_RESULT):
    return fetchConfigResultsPending(state, action);
  case withRejected(FETCH_EVOLUTIVO_RESULT):
    return fetchConfigResultsRejected(state, action);
  case withFulFilled(FETCH_EVOLUTIVO_RESULT):
    return fetchConfigResultsFulfilled(state, action);

    /**
     * Remoção
     */
  case withPending(REMOVE_EVOLUTIVO_CONFIG):
    return listConfigurationsPending(state, action);
  case withRejected(REMOVE_EVOLUTIVO_CONFIG):
    return listConfigurationsRejected(state, action);
  case withFulFilled(REMOVE_EVOLUTIVO_CONFIG):
    return listConfigurationsFulfilled(state, action);

    /**
     * Atualização do cadastro
     */
  case withPending(UPDATE_EVOLUTIVO_CONFIG):
    return updateConfigurationPending(state, action);
  case withRejected(UPDATE_EVOLUTIVO_CONFIG):
    return updateConfigurationRejected(state, action);
  case withFulFilled(UPDATE_EVOLUTIVO_CONFIG):
    return updateConfigurationFulfilled(state, action);

    /**
     * Seleção de configuração
     */
  case SELECT_EVOLUTIVO_CONFIG:
    return {
      ...state,
      configuration: { ...state.configuration, selected: action.payload },
    };

  default:
    return state;
  }
};

export default execute;
